import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import { OAUTH } from '../lib/constants';

export function AuthCompletePage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const { discardLocalSession } = useAuth();
  const [attempted, setAttempted] = useState(false);
  const redirectUri = searchParams.get(OAUTH.PARAM.REDIRECT_URI) ?? '';
  const code = searchParams.get('code') ?? '';
  const state = searchParams.get(OAUTH.PARAM.STATE) ?? undefined;

  const callbackUrl = (() => {
    if (!redirectUri || !code) return '';
    const url = new URL(redirectUri);
    url.searchParams.set('code', code);
    if (state) url.searchParams.set(OAUTH.PARAM.STATE, state);
    return url.toString();
  })();

  useEffect(() => {
    if (!callbackUrl || attempted) return;
    discardLocalSession();
    setAttempted(true);
    window.location.href = callbackUrl;
  }, [attempted, callbackUrl, discardLocalSession]);

  return (
    <div className="center-screen">
      <div className="chooser-card">
        <p className="chooser-card__eyebrow">Authentication complete</p>
        <h1>Return to the app</h1>
        <p className="chooser-card__copy">
          {callbackUrl
            ? 'Your session is ready. If the app did not open automatically, use the button below.'
            : 'Missing authorization code. Sign in again from the mobile app.'}
        </p>

        {callbackUrl ? (
          <div className="chooser-actions">
            <a className="primary-button" href={callbackUrl}>
              Open app
            </a>
          </div>
        ) : (
          <div className="form-error">Missing redirect URI or code.</div>
        )}
      </div>
    </div>
  );
}
